import { render } from "./MobileBlogger.vue?vue&type=template&id=63276146&scoped=true"
import script from "./MobileBlogger.vue?vue&type=script&lang=js"
export * from "./MobileBlogger.vue?vue&type=script&lang=js"

import "./MobileBlogger.vue?vue&type=style&index=0&id=63276146&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63276146"]])

export default __exports__